import React from 'react';

const BarcoVolteado = () => (
    <img src={process.env.PUBLIC_URL + '/images/Barco_solo_sin_fondo.svg'} alt="Barco" style={{ width: '2em', height: '2em' }} />
);

export default BarcoVolteado;
